<table class="table" style="background-color:white;">

  <tr>
    <td style="background-color:#0f2b46;color:white;" colspan="2"> Reset Password </td>
    <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
  </tr>
</table>




<p class="logo-title">Security alert : Dear user due to enchance security exercise request you to reset your password</p>

<form [formGroup]="OpenchangepasswordForm" (ngSubmit)="forgetPassword(OpenchangepasswordForm.value)">
  <!--<div *ngIf="change==false">-->
  <div>
    <mat-form-field class="col-lg-8">
      <input matInput placeholder="Email Id" formControlName="emailId" maxlength="100" required />
      <mat-error *ngIf="submitted && f.emailId.errors">
        Enter Registered Email Id
      </mat-error>
    </mat-form-field>

    <button type="button" class="commn-btn col-lg-3" mat-raised-button color="primary" (click)="sendCode()">Send Code</button>
  </div>
  <!--<div *ngIf="change==true">-->
  <div>
    <mat-form-field class="col-lg-4">
      <input matInput placeholder="Verify Code" formControlName="verifyCode" NumberOnly maxlength="6" required />
      <mat-error *ngIf="submitted && f.verifyCode.errors">
        Enter Verify Code
      </mat-error>
    </mat-form-field>


    <mat-form-field class="col-lg-4">
      <input type="password" matInput placeholder="New Password" formControlName="newPassword" maxlength="20"
             minlength="8" required />
      <mat-error *ngIf="submitted && f.newPassword.errors?.required">
         Enter New Password
      </mat-error>
      <mat-error *ngIf="f.newPassword.hasError('pattern')">
        New Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
      </mat-error>
    </mat-form-field>

    <mat-form-field class="col-lg-4">
      <input type="password" matInput placeholder="Confirm Password" formControlName="confirmPassword" maxlength="20" minlength="8" required />
      <mat-error *ngIf="submitted && f.confirmPassword.errors?.required">
        Enter Confirm Password
      </mat-error>
      <mat-error *ngIf="f.confirmPassword.hasError('pattern')">
        Confirm Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
      </mat-error>
      <mat-error *ngIf="f.confirmPassword.hasError('confirmPasswordValidator')">New Password and Confirm Password must be match</mat-error>

    </mat-form-field>


    <div style="display: flex;justify-content: center;align-items: center;">
      <button type="submit" class="commn-btn col-lg-3" mat-raised-button color="primary">Submit</button>
    </div>
  </div>
</form>

